/**
 * @generated SignedSource<<7b253ff54fcf770741a153ee3b62fad6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type PreviewWidgetKPIInput = {
  dataSource: string;
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
};
export type WAIntegrationKPIQuery$variables = {
  input: PreviewWidgetKPIInput;
  storecastId: string;
};
export type WAIntegrationKPIQuery$data = {
  readonly dashboard: {
    readonly previewWidgetKPI: {
      readonly dataSource: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetKPI_widgetKPI">;
    };
  };
};
export type WAIntegrationKPIQuery = {
  response: WAIntegrationKPIQuery$data;
  variables: WAIntegrationKPIQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataSource",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationKPIQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetKPI",
              "kind": "LinkedField",
              "name": "previewWidgetKPI",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetKPI_widgetKPI"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationKPIQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetKPI",
            "kind": "LinkedField",
            "name": "previewWidgetKPI",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetKPITile",
                "kind": "LinkedField",
                "name": "tiles",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subtitle",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetKPITileTrend",
                    "kind": "LinkedField",
                    "name": "trends",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "change",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "compareValue",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "graph",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "WidgetKPITileGraphBar",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "WidgetKPITileGraphSlider",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "negative",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "positive",
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetKPITileGraphRegions",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetKPITileGraphGaugePart",
                            "kind": "LinkedField",
                            "name": "gaugeParts",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mode",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetKPITileGraphGaugeIndicator",
                            "kind": "LinkedField",
                            "name": "indicators",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "WidgetKPITileGraphGauge",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "264a35f80d13879f7a81577da2c7fb31",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationKPIQuery",
    "operationKind": "query",
    "text": "query WAIntegrationKPIQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetKPIInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetKPI(input: $input) {\n      dataSource\n      ...WidgetKPI_widgetKPI\n      id\n    }\n    id\n  }\n}\n\nfragment Tile_kpiTile on WidgetKPITile {\n  title\n  subtitle\n  value\n  unit\n  trends {\n    change\n    label\n    compareValue\n    type\n  }\n  graph {\n    __typename\n    label\n    ... on WidgetKPITileGraphBar {\n      __typename\n      ...Tile_kpiTileGraphBar\n    }\n    ... on WidgetKPITileGraphSlider {\n      __typename\n      ...Tile_kpiTileGraphSlider\n    }\n    ... on WidgetKPITileGraphRegions {\n      __typename\n      ...Tile_kpiTileGraphRegions\n    }\n    ... on WidgetKPITileGraphGauge {\n      __typename\n      ...Tile_kpiTileGraphGauge\n    }\n  }\n}\n\nfragment Tile_kpiTileGraphBar on WidgetKPITileGraphBar {\n  parts\n}\n\nfragment Tile_kpiTileGraphGauge on WidgetKPITileGraphGauge {\n  gaugeParts {\n    color\n    value\n    mode\n  }\n  indicators {\n    type\n    value\n  }\n}\n\nfragment Tile_kpiTileGraphRegions on WidgetKPITileGraphRegions {\n  negative\n  positive\n}\n\nfragment Tile_kpiTileGraphSlider on WidgetKPITileGraphSlider {\n  parts\n}\n\nfragment WidgetKPI_widgetKPI on WidgetKPI {\n  id\n  title\n  dataSource\n  tiles {\n    ...Tile_kpiTile\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f1f423a2064181f385bbe833073dc79";

export default node;
